/* eslint-disable import-extensions/file-extension-required */
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import FetchMediaTokenQuery, {
	type graphqlHelpersFetchMediaTokenQuery$data,
	type graphqlHelpersFetchMediaTokenQuery$variables,
} from '../MediaProvider/__generated__/graphqlHelpersFetchMediaTokenQuery.graphql';

export const preloadMediaToken = async (contentId: string) => {
	const response = await query<
		graphqlHelpersFetchMediaTokenQuery$data,
		graphqlHelpersFetchMediaTokenQuery$variables
	>({
		query: FetchMediaTokenQuery,
		variables: {
			contentId,
			status: ['current', 'draft', 'archived'],
		},
	});

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const { mediaConfigRecorder } = await import(
			/* webpackChunkName: "loadable-confluencessr-utilities-objectrecorder" */ '@confluence/ssr-utilities/entry-points/ObjectRecorder.ts'
		);
		mediaConfigRecorder.set({
			clientId: response?.data?.mediaConfiguration?.clientId || '',
			baseUrl: response?.data?.mediaConfiguration?.fileStoreUrl || '',
			token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
		});
	}

	return response;
};
